module.exports = __webpack_public_path__ + "static/media/Overjet (sagittal fissure)11.13f38a3b.png";